<template>
  <div class="salesman-form-base" v-loading="loading">
    <Form ref="form" :model="formData" :label-width="90" class="page-form">
      <FormItem prop="staffNo" class="flex" label="工号" :rules="$units.formRule.required('请输入')">
        <Input v-model="formData.staffNo" placeholder="请输入" />
        <Button class="save-btn" type="primary" @click="createStaffNo">自动生成</Button>
      </FormItem>
      <FormItem prop="name" label="姓名" :rules="$units.formRule.required('请输入')">
        <Input v-model="formData.name" placeholder="请输入" />
      </FormItem>
      <FormItem prop="mobile" label="手机号" :rules="oldMobile || registerId ? { required: true } : $units.formRule.tel('请输入正确的手机号', true)">
        <div class="tips">
          <Input
            v-if="formData.eyeShow || !formData.id || !mobileEye"
            v-model="formData.mobile"
            placeholder="请输入"
            @on-change="mobileChange"
            :disabled="!!registerId"
          />
          <Input v-else v-model="formData.mobile1" placeholder="请输入" @on-change="mobileChange" :disabled="!!registerId" />
          <span v-if="mobileEye && formData.mobile1">
            <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow && formData.id" @click="openEye('mobile', 'eyeShow')"></i>
            <i class="iconfont iconyincang eye-icon" v-else-if="!formData.eyeShow && formData.id" @click="openEye('mobile', 'eyeShow')"></i>
          </span>
        </div>
      </FormItem>
      <FormItem label="所属机构" prop="organizationId" v-if="registerId || !formData.id" :rules="$units.formRule.required('请选择')">
        <select-tree
          type="4"
          v-model="formData.organizationId"
          :isAll="true"
          ref="selectTree"
          @change="getGroupList"
          :status="registerId ? '1' : '-1'"
        ></select-tree>
      </FormItem>
      <FormItem label="所属机构" v-else>
        <Input :value="formData.organizationName" disabled />
      </FormItem>
      <FormItem prop="entryTime" label="入职日期" :rules="$units.formRule.objRequired('请选择')">
        <DatePicker type="date" v-model="formData.entryTime" format="yyyy-MM-dd" placeholder="请选择"></DatePicker>
      </FormItem>
      <FormItem prop="workingState" label="状态">
        <RadioGroup v-model="formData.workingState">
          <Radio label="1" :disabled="formData.id ? true : false">在职</Radio>
          <Radio label="0" :disabled="formData.id ? true : false">离职</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="离职时间" v-if="formData.workingState == 0" prop="resignTime" :rules="$units.formRule.objRequired('请选择')">
        <DatePicker type="date" v-model="formData.resignTime" format="yyyy-MM-dd" placeholder="请选择"></DatePicker>
      </FormItem>
      <FormItem prop="sex" label="性别">
        <RadioGroup v-model="formData.sex">
          <Radio label="1">男</Radio>
          <Radio label="2">女</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="证件类型" prop="idType" :rules="$units.formRule.required('请选择')">
        <Select v-model="formData.idType" clearable @on-change="$set(formData, 'idNo', '')">
          <Option v-for="(item, index) in idTypeList" :value="item.value" :key="index">{{ item.txt }}</Option>
        </Select>
      </FormItem>
      <FormItem
        prop="idNo"
        label="证件号"
        :rules="oldIdNo || idEye ? { required: true, message: '请输入正确的身份证号' } : $units.formRule.idCard()"
        v-if="formData.idType == '01'"
        key="idNo1"
      >
        <div class="tips">
          <Input v-if="formData.eyeShow1 || !formData.id || !idEye" v-model="formData.idNo" placeholder="请输入" @on-change="idCardChange" />
          <Input v-else v-model="formData.idNo1" placeholder="请输入" @on-change="idCardChange" />
          <span v-if="idEye && formData.idNo1">
            <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow1" @click="openEye('idNo', 'eyeShow1')"></i>
            <i class="iconfont iconyincang eye-icon" v-else-if="!formData.eyeShow1 && formData.id" @click="openEye('idNo', 'eyeShow1')"></i>
          </span>
        </div>
      </FormItem>
      <FormItem prop="idNo" label="证件号" :rules="strLength()" v-else key="-">
        <div class="tips">
          <Input v-if="formData.eyeShow1 || !formData.id || !idEye" v-model="formData.idNo" placeholder="请输入" @on-change="idCardChange($event, 1)" />
          <Input v-else v-model="formData.idNo1" placeholder="请输入" @on-change="idCardChange($event, 1)" />
          <span v-if="idEye && formData.idNo1">
            <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow1" @click="openEye('idNo', 'eyeShow1')"></i>
            <i class="iconfont iconyincang eye-icon" v-else-if="!formData.eyeShow1 && formData.id" @click="openEye('idNo', 'eyeShow1')"></i>
          </span>
        </div>
      </FormItem>
      <FormItem prop="date" label="证件有效期">
        <DatePicker
          type="date"
          v-model="formData.date2"
          format="yyyy-MM-dd"
          placeholder="请选择"
          key="date"
          style="width: calc(100% - 65px); margin-right: 7px"
          v-if="formData.isLongEffective == 1"
        ></DatePicker>
        <DatePicker
          type="daterange"
          v-model="formData.date"
          format="yyyy-MM-dd"
          placeholder="请选择"
          key="daterange"
          style="width: calc(100% - 65px); margin-right: 7px"
          v-else
        ></DatePicker>
        <i-switch v-model="formData.isLongEffective" size="large" true-value="1" false-value="0" @on-change="isLongEffectiveChange">
          <span slot="open">长期</span>
          <span slot="close">短期</span>
        </i-switch>
      </FormItem>
      <FormItem label="出生日期" v-if="formData.idType == '01'" key="idType01">
        <Input :value="formData.birthday" placeholder="根据身份证号自动显示" disabled />
      </FormItem>
      <FormItem label="出生日期" v-else key="!idType01">
        <DatePicker type="date" v-model="formData.birthday" format="yyyy-MM-dd" placeholder="请选择" @on-change="changeBirthday"> </DatePicker>
      </FormItem>
      <FormItem prop="outlook" label="政治面貌">
        <lzDicSelect v-model="formData.outlook" dicType="OUTLOOK"></lzDicSelect>
      </FormItem>
      <FormItem prop="nation" label="民族">
        <Select v-model="formData.nation" filterable>
          <Option v-for="text in nationList" :value="text" :key="text">{{ text }}</Option>
        </Select>
      </FormItem>
      <FormItem prop="maritalStatus" label="婚姻状态">
        <lzDicSelect v-model="formData.maritalStatus" dicType="MARITAL"></lzDicSelect>
      </FormItem>
      <FormItem prop="education" label="学历">
        <lzDicSelect v-model="formData.education" dicType="EDUCATION"></lzDicSelect>
      </FormItem>
      <FormItem prop="email" label="邮箱" :rules="oldEmail || emailEye ? { required: false, message: '请输入正确的邮箱地址' } : $units.formRule.email(false)">
        <div class="tips">
          <Input v-if="formData.eyeShow2 || !emailEye" v-model="formData.email" placeholder="请输入" @on-change="emailChange" />
          <Input v-else v-model="formData.email1" placeholder="请输入" @on-change="emailChange" />
          <span v-if="emailEye && formData.email1">
            <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow2" @click="openEye('email', 'eyeShow2')"></i>
            <i class="iconfont iconyincang eye-icon" v-else @click="openEye('email', 'eyeShow2')"></i>
          </span>
        </div>
      </FormItem>

      <br />
      <FormItem
        prop="cardNo"
        label="银行卡号"
        :rules="
          oldCardNo || cardNoEye
            ? { required: false, message: '请输入正确的银行卡号' }
            : { required: false, validator: validateMessage, message: '请输入正确的银行卡号', trigger: 'change' }
        "
      >
        <div class="tips">
          <Input v-if="formData.eyeShow3 || !cardNoEye" v-model="formData.cardNo" placeholder="请输入" @on-change="cardNoChange" />
          <Input v-else v-model="formData.cardNo1" placeholder="请输入" @on-change="cardNoChange" />
          <span v-if="cardNoEye && formData.cardNo1">
            <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow3" @click="openEye('cardNo', 'eyeShow3')"></i>
            <i class="iconfont iconyincang eye-icon" v-else @click="openEye('cardNo', 'eyeShow3')"></i>
          </span>
        </div>
      </FormItem>
      <FormItem prop="bank" label="开户银行">
        <Select v-model="formData.bank" filterable clearable>
          <Option v-for="(txt, value) in bankList" :value="value" :key="value">{{ txt }}</Option>
        </Select>
      </FormItem>
      <FormItem prop="accountOpenBranch" label="银行支行">
        <Input v-model="formData.accountOpenBranch" placeholder="请输入" />
      </FormItem>
      <FormItem label="社保号">
        <Input v-model="formData.socialNo" placeholder="请输入" />
      </FormItem>
      <FormItem label="公积金账号">
        <Input v-model="formData.accumulationNo" placeholder="请输入" />
      </FormItem>
      <FormItem label="银行开户城市">
        <Select v-model="formData.bankProvince" placeholder="省" @on-change="provinceChange('bank', $event)" filterable style="width: calc(50% - 5px)">
          <Option v-for="(item, i) in regionsArr" :value="item.name" :key="i">{{ item.name }}</Option>
        </Select>
        <Select v-model="formData.bankCity" placeholder="市" filterable style="width: calc(50% - 5px); margin-left: 10px">
          <Option v-for="(item, i) in cityList" :value="item.name" :key="i">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="所在省市">
        <Select v-model="formData.province" placeholder="省" @on-change="provinceChange('user', $event)" filterable style="width: calc(50% - 5px)">
          <Option v-for="(item, i) in regionsArr" :value="item.name" :key="i">{{ item.name }}</Option>
        </Select>
        <Select v-model="formData.city" placeholder="市" filterable style="width: calc(50% - 5px); margin-left: 10px">
          <Option v-for="(item, i) in cityList2" :value="item.name" :key="i">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem
        prop="address"
        label="具体地址"
        class="two"
        :rules="
          oldAddress || addressEye
            ? { required: false, message: '请输入正确的地址' }
            : { required: false, validator: validateMessage, message: '请输入正确的地址', trigger: 'change' }
        "
      >
        <div class="tips">
          <Input
            v-if="formData.eyeShow4 || !addressEye"
            v-model="formData.address"
            @on-change="addressChange"
            type="textarea"
            placeholder="最多不超过30个字"
            maxlength="30"
            :autosize="{ minRows: 1 }"
            show-word-limit
          />
          <Input
            v-else
            v-model="formData.address1"
            @on-change="addressChange"
            type="textarea"
            placeholder="最多不超过30个字"
            maxlength="30"
            :autosize="{ minRows: 1 }"
            show-word-limit
          />
          <span v-if="addressEye && formData.address1">
            <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow4" @click="openEye('address', 'eyeShow4')"></i>
            <i class="iconfont iconyincang eye-icon" v-else @click="openEye('address', 'eyeShow4')"></i>
          </span>
        </div>
      </FormItem>
      <FormItem label="身高(cm)" prop="height" :rules="$units.formRule.IntSort()">
        <Input v-model="formData.height" placeholder="请输入" />
      </FormItem>
      <FormItem label="体重(kg)" prop="weight" :rules="$units.formRule.IntSort()">
        <Input v-model="formData.weight" placeholder="请输入" />
      </FormItem>
      <FormItem label="健康状况" prop="health">
        <lzDicSelect v-model="formData.health" dicType="HEAITH_COND"></lzDicSelect>
      </FormItem>
      <FormItem label="犯罪记录" prop="criminalRecord">
        <lzDicSelect v-model="formData.criminalRecord" dicType="HAVE_NOT"></lzDicSelect>
      </FormItem>
      <FormItem label="监管处罚记录" prop="penaltyRecord">
        <lzDicSelect v-model="formData.penaltyRecord" dicType="HAVE_NOT"></lzDicSelect>
      </FormItem>
      <FormItem label="继承人" v-show="formData.workingState == 0">
        <Select v-model="formData.heir" placeholder="请选择" filterable :transfer="true" :disabled="!!formData.id">
          <Option v-for="(item, i) in userList" :value="item.id" :key="i" v-if="item.id != formData.id && item.workingState == '1'">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <div v-for="(item, i) in formData.userContactsList" :key="'userContactsList' + i">
        <FormItem :label="`紧急联系人` + (i + 1)">
          <Input v-model="item.name" placeholder="请输入" />
        </FormItem>
        <FormItem label="紧急联系电话">
          <div class="tips">
            <Input v-if="item.eyeShow || !formData.id || item.mobileEye" v-model="item.mobile" @on-change="mobileChange1($event, i)" placeholder="请输入" />
            <Input v-else v-model="item.mobile1" placeholder="请输入" @on-change="mobileChange1($event, i)" />
            <span v-if="!item.mobileEye && item.mobile">
              <i class="iconfont iconxianshi eye-icon" v-if="item.eyeShow && item.id" @click="openEye('mobile', 'eyeShow', i)"></i>
              <i class="iconfont iconyincang eye-icon" v-else-if="!item.eyeShow && item.id" @click="openEye('mobile', 'eyeShow', i)"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="与本人关系">
          <Select v-model="item.reason">
            <Option value="1">父母</Option>
            <Option value="2">配偶</Option>
            <Option value="3">子女</Option>
            <Option value="4">亲戚</Option>
            <Option value="5">朋友</Option>
            <Option value="6">其他</Option>
          </Select>
        </FormItem>
      </div>
      <FormItem label="备注" class="full">
        <Input v-model="formData.remarkExplain" type="textarea" placeholder="最多不超过100个字" maxlength="100" :autosize="{ minRows: 3 }" show-word-limit />
      </FormItem>
      <div class="form-title">账号信息</div>
      <div v-for="(bean, i) in formData.userAccountInfos" :key="'acc' + i">
        <p v-if="formData.userAccountInfos.length > 1">账号{{ i + 1 }}</p>
        <!-- <FormItem label="登录账号" :prop="`userAccountInfos.${i}.account`" :rules="$units.formRule.required('请输入')"> -->
        <FormItem label="登录账号" :prop="`userAccountInfos.${i}.account`">
          <Input v-model="bean.account" placeholder="请输入" :disabled="!!formData.id" />
        </FormItem>
        <!-- <FormItem label="登录密码" :prop="`userAccountInfos.${i}.password`" :rules="pwdRule()" :class="{ 'has-btn': formData.id }"> -->
        <FormItem label="登录密码" :prop="`userAccountInfos.${i}.password`" :class="{ 'has-btn': formData.id }">
          <Input type="password" :password="!formData.id" v-model="bean.password" placeholder="请输入密码" :disabled="!!formData.id" />
          <a class="text" @click="$refs.passwordForm.open(bean)" v-if="formData.id">重置</a>
          <div class="info-text">密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种</div>
        </FormItem>
        <!-- <FormItem label="角色" :prop="`userAccountInfos.${i}.roleIds`" :rules="$units.formRule.arrRequired('请输入')" class="has-btn"> -->
        <FormItem label="角色" :prop="`userAccountInfos.${i}.roleIds`" class="has-btn">
          <template v-if="formData.id">
            <Input type="text" v-model="bean.roleName" placeholder="请输入密码" :disabled="!!formData.id" />
            <a class="text" @click="$refs.changeRole.open(bean)">变更</a>
          </template>
          <template v-else>
            <Select v-model="bean.roleIds" clearable filterable transfer :multiple="true" :disabled="!!formData.id">
              <Option :value="item.id" v-for="(item, index) in roleLsit" :key="index">{{ item.name }}</Option>
            </Select>
            <a class="text" @click="addRole">新增</a>
          </template>
        </FormItem>
        <!-- <FormItem label="手机号" :prop="`userAccountInfos.${i}.mobile3`" :rules="$units.formRule.required('请输入')"> -->
        <FormItem label="手机号" :prop="`userAccountInfos.${i}.mobile3`">
          <Input v-model="bean.mobile3" clearable :maxlength="11" placeholder="请输入手机号" :disabled="!!formData.id" />
        </FormItem>
        <!-- <FormItem :prop="`userAccountInfos.${i}.dataType`" :rules="$units.formRule.required('请选择')" label :label-width="100"> -->
        <FormItem :prop="`userAccountInfos.${i}.dataType`" label :label-width="100">
          <span slot="label" class="label">
            数据权限<span class="tip-icon">?</span>
            <div class="pop-tip">
              <span>本级机构及下级机构：支持查看当前及所有下级机构数据</span><br />
              <span>单独配置：自行配置此账号查看的数据范围，不可查看未勾选机构的数据</span>
              <div class="arrow"></div>
            </div>
          </span>
          <RadioGroup v-model="bean.dataType" style="margin-top: -1px" @on-change="changeOrgSetUp" :disabled="!!formData.id">
            <Radio label="1" :disabled="!!formData.id">本机构及下级机构</Radio>
            <Radio label="2" :disabled="!!formData.id">单独设置</Radio>
          </RadioGroup>
        </FormItem>
        <!-- <FormItem
          :prop="`userAccountInfos.${i}.dataOrgIds`"
          label=""
          :rules="$units.formRule.arrRequired('请选择数据权限')"
          class="full"
          v-if="bean.dataType == '2'"
        > -->
        <FormItem :prop="`userAccountInfos.${i}.dataOrgIds`" label="" class="full" v-if="bean.dataType == '2'">
          <authTree v-model="bean.dataOrgIds" :orgId="formData.organizationId" :disabled="!!formData.id"></authTree>
        </FormItem>
        <!-- <FormItem
          :prop="`userAccountInfos.${i}.supervise`"
          :rules="$units.formRule.required('请选择')"
          label="简洁模式"
          :label-width="100"
          v-if="$units.superviseShowVal()"
        >    -->
        <FormItem :prop="`userAccountInfos.${i}.supervise`" label="简洁模式" :label-width="100" v-if="$units.superviseShowVal()">
          <span slot="label" class="label">
            简洁模式<span class="tip-icon">?</span>
            <div class="pop-tip">
              <span>简洁模式为监管模式，开启后您不能主动退出，非监管数据将会隐藏</span>
              <div class="arrow"></div>
            </div>
          </span>
          <RadioGroup v-model="bean.supervise" style="margin-top: -1px">
            <Radio label="0" :disabled="!!formData.id">否</Radio>
            <Radio label="1" :disabled="!!formData.id">是</Radio>
          </RadioGroup>
        </FormItem>
      </div>
    </Form>

    <!-- 新增职级 -->
    <edit-promotion ref="editPromotion" @reload="getRankList"></edit-promotion>
    <!-- 变更角色 -->
    <change-role ref="changeRole" :initList="getUserData"></change-role>
    <!-- 重置密码 -->
    <password-form ref="passwordForm"></password-form>
  </div>
</template>

<script>
import editPromotion from '@/pages/personnelMag/promotionManage/components/editModal';
import passwordForm from '@/pages/systemSet/accountNumManage/components/passwordForm';
import changeRole from '@/pages/systemSet/accountNumManage/components/changeRole';
import selectTree from '@/components/system/selectTree3';
import lzDicSelect from '@/components/commons/lzDicSelect';
import authTree from './authTree';
import filter from '@/api/filter';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: {
    editPromotion,
    changeRole,
    passwordForm,
    authTree,
    selectTree,
    lzDicSelect
  },
  data() {
    return {
      loading: false,
      mobileEye: true,
      idEye: true,
      emailEye: true,
      cardNoEye: true,
      addressEye: true,
      oldMobile: '',
      oldIdNo: '',
      oldEmail: '',
      oldCardNo: '',
      oldAddress: '',
      rankList: [], //职级
      roleLsit: [], //角色
      bankList: [], //银行
      nationList: [], //民族
      regionsArr: [], //区域数据
      cityList: [], //市级数据 银行
      cityList2: [], //市级数据
      userList: [], //当前机构业务员
      recommenderList: [], //推荐人列表
      idTypeList: [], //证件类型
      formData: {
        isLongEffective: '0',
        userContactsList: [{}, {}],
        isSus: '0',
        workingState: '1',
        idType: '01',
        supervise: '1'
      },
      accountItem: {
        account: '',
        password: '',
        mobile3: '',
        dataType: '1',
        supervise: '0',
        dataOrgIds: [],
        roleIds: []
      },
      indoorStaffId: '', //内勤人员id
      registerId: '', //立即入职id
      dic: {},
      userInfo: {}
    };
  },
  created() {
    this.indoorStaffId = this.$route.query.indoorStaffId;
    this.registerId = this.$route.query.registerId;
    this.dic = JSON.parse(localStorage.dic);
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
  },
  activated() {
    this.queryRoleList();
  },
  methods: {
    // 切换数据权限类型
    changeOrgSetUp(value) {
      // 本机构
      if (value == 2 && this.formData.buzOrganId) {
        this.$nextTick(() => {
          this.$refs.selectTreeRef.openChange(true);
        });
      }
    },
    // 新增角色
    addRole() {
      this.$router.push({
        path: '/systemSet/roleManageAdd',
        query: {
          t: new Date().getTime(),
          backUrl: this.delQueStr(this.$route.fullPath, 'time')
        }
      });
    },
    // 获取角色列表
    queryRoleList() {
      if (!this.formData.organizationId) return;
      this.$http({
        url: '/buz/rolesExt/listRoles',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 999,
          organizationId: this.formData.organizationId
        }
      }).then(res => {
        this.roleLsit = res.data;
      });
    },
    // 密码格式校验
    pwdRule() {
      return {
        required: true,
        trigger: 'change',
        validator: (rule, value, callback) => {
          if (this.formData.id) {
            callback();
          } else if (value === '') {
            callback(new Error('请输入密码'));
          } else if (!this.pwdVerification(value)) {
            callback(new Error('密码格式有误，请检查'));
          } else {
            callback();
          }
        }
      };
    },
    // 密码规则
    pwdVerification(password) {
      const capital = /[A-Z]/;
      const regLetter = /[a-z]/;
      const regNum = /[0-9]/;
      const regTeShu = new RegExp("[`_~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]");
      let complex = 0;
      if (capital.test(password)) {
        ++complex;
      }
      if (regLetter.test(password)) {
        ++complex;
      }
      if (regNum.test(password)) {
        ++complex;
      }
      if (regTeShu.test(password)) {
        ++complex;
      }
      if (complex < 3 || password.length < 8 || password.length > 16) {
        return false;
      } else {
        return true;
      }
    },
    validateMessage(rule, value, callback) {
      if (value.indexOf('*') != -1) {
        callback(new Error('请输入正确的格式'));
      }
      callback();
    },
    // 解密
    openEye(key, showKey, val) {
      if (this.formData[showKey]) {
        this.formData[key] = this.formData[key + '1'];
      }

      if (val != undefined && String(val)) {
        if (!this.formData.userContactsList[val][showKey]) {
          this.descrypt(
            {
              query: this.formData.id,
              operationFunction: 25,
              operationType: 6,
              otherInfo: {
                userContactsId: this.formData.userContactsList[val].id
              }
            },
            this.formData.userContactsList[val],
            key
          ).then(() => {
            this.$set(this.formData.userContactsList[val], showKey, true);
          });
        } else {
          this.$set(this.formData.userContactsList[val], showKey, false);
        }
      } else {
        if (!this.formData[showKey]) {
          const map = {
            idNo: 1,
            mobile: 2,
            cardNo: 3,
            email: 4,
            address: 5
          };
          this.descrypt(
            {
              query: this.formData.id,
              operationFunction: 25,
              operationType: map[key]
            },
            this.formData,
            key
          ).then(() => {
            this.$set(this.formData, showKey, true);
          });
        } else {
          this.$set(this.formData, showKey, false);
        }
      }
    },
    strLength() {
      return {
        required: true,
        trigger: 'change',
        validator(rule, value, callback) {
          if (!value) {
            callback(new Error('请输入证件号'));
          } else if (value.length < 6) {
            callback(new Error('证件号至少6位'));
          } else {
            callback();
          }
        }
      };
    },
    //自动生成工号
    createStaffNo() {
      this.$http({
        type: 'GET',
        url: '/buz/userBase/auto/staffNo',
        data: {
          orgId: this.formData.organizationId,
          groupId: this.formData.groupId
        }
      }).then(res => {
        console.log(res);
        this.$set(this.formData, 'staffNo', res.data);
      });
    },
    save() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate().then(isok => {
          if (!isok) {
            reject({ page: 'base', showMsg: true });
            return;
          }
          const formData = JSON.parse(JSON.stringify(this.formData));
          formData.userAccountInfos.forEach(item => {
            item.dataOrgIds = item.dataOrgIds.join(',');
          });
          if (!formData.id) {
            formData.usersExtDTO = formData.userAccountInfos[0];
          }
          delete formData.userAccountInfos;
          formData.entryTime = this.$units.formatDate(formData.entryTime);
          if (formData.isLongEffective == 1) {
            formData.effectiveTimeStart = this.$units.formatDate(formData.date2);
            formData.effectiveTimeEnd = '';
          } else if (formData.date && formData.date[0]) {
            formData.effectiveTimeStart = this.$units.formatDate(formData.date[0]);
            formData.effectiveTimeEnd = this.$units.formatDate(formData.date[1]);
          }
          if (this.oldMobile == formData.mobile) {
            delete formData.mobile;
          }
          if (this.oldIdNo == formData.idNo) {
            delete formData.idNo;
          }
          // 处理非身份证出生日期格式
          if (formData.birthday && formData.idType != '01') {
            formData.birthday = filter.filterTime(formData.birthday, 'YYYY-MM-DD');
          }
          if (
            formData.usersExtDTO &&
            (formData.usersExtDTO.account || formData.usersExtDTO.password || formData.usersExtDTO.roleIds.length || formData.usersExtDTO.mobile3)
          ) {
            //校验账号信息
            if (
              !formData.usersExtDTO.account ||
              formData.usersExtDTO.roleIds.length == 0 ||
              !formData.usersExtDTO.mobile3 ||
              formData.usersExtDTO.password === '' ||
              !this.pwdVerification(formData.usersExtDTO.password)
            ) {
              this.$notice.msg('请完善账号信息信息');
              reject({ page: 'base', showMsg: false });
              return;
            }
          } else {
            delete formData.usersExtDTO;
          }
          this.$http({
            type: 'POST',
            url: formData.id ? '/buz/indoorStaff/edit' : '/buz/indoorStaff/add',
            data: formData,
            apiPermissionCode: 'org_4_2'
          })
            .then(res => {
              resolve();
              this.mobileEye = true;
              this.idEye = true;
              this.oldMobile = this.formData.mobile;
              this.oldIdNo = this.formData.idNo;
              this.oldEmail = this.formData.email;
              this.oldCardNo = this.formData.cardNo;
              this.oldAddress = this.formData.address;
              if (!this.indoorStaffId) {
                this.$emit('save', res.data);
              }
            })
            .catch(res => {
              reject({ page: 'base' });
            });
        });
      });
    },
    async setData() {
      this.oldMobile = '';
      this.oldIdNo = '';

      await this.getRegion();
      await this.getUserData();
      this.getCardType();
      this.getRankList();
      this.getBankList();
      this.getNationList();
      this.getUserList();
      this.getRecommenderList();
    },
    addressChange(e) {
      this.$set(this.formData, 'address', e.target.value);
      this.oldAddress = '';
      this.addressEye = false;
    },
    emailChange(e) {
      this.$set(this.formData, 'email', e.target.value);
      this.oldEmail = '';
      this.emailEye = false;
    },
    // 手机号修改
    mobileChange(e) {
      this.$set(this.formData, 'mobile', e.target.value);
      this.oldMobile = '';
      this.mobileEye = false;
    },
    // 紧急联系人修改
    mobileChange1(e, val) {
      this.$set(this.formData.userContactsList, 'mobile', e.target.value);
      this.formData.userContactsList[val].mobileEye = true;
    },
    // 业务员数据,清空数据
    getUserData() {
      if (!this.indoorStaffId) {
        //新增不执行
        this.$refs.form && this.$refs.form.resetFields();
        this.formData = {
          date2: null,
          isLongEffective: '0',
          userContactsList: [{}, {}],
          userAccountInfos: [JSON.parse(JSON.stringify(this.accountItem))],
          isSus: '0',
          workingState: '1',
          idType: '01',
          supervise: '1',
          groupId: this.$route.query.groupId,
          organizationId: this.$route.query.organizationId
        };
        this.$nextTick(() => {
          this.$refs.selectTree && this.$refs.selectTree.openChange();
        });
        console.log('this.formData', this.formData);
        return;
      }
      this.loading = true;
      return this.$http({
        url: '/buz/indoorStaff/read/detail',
        type: 'get',
        data: {
          id: this.indoorStaffId
        }
      })
        .then(res => {
          this.loading = false;
          const data = res.data;
          if (!data.userContactsList || data.userContactsList.length == 0) {
            data.userContactsList = [{}, {}];
          }
          // 账号数据处理
          if (!data.userAccountInfos || data.userAccountInfos.length == 0) {
            data.userAccountInfos = [JSON.parse(JSON.stringify(this.accountItem))];
          } else {
            data.userAccountInfos.forEach(item => {
              item.password = '********';
              item.mobile3 = item.mobile;
              item.dataOrgIds = item.dataOrgIds ? item.dataOrgIds.split(',') : [];
              item.roleIds = item.roleId ? item.roleId.split(',') : [];
            });
          }
          data.isLongEffective = data.isLongEffective == 1 ? '1' : '0';
          data.entryTime = data.entryTime ? this.$units.formatDate(data.entryTime) : data.entryTime;
          if (data.effectiveTimeStart && data.effectiveTimeEnd) {
            data.date = [new Date(data.effectiveTimeStart), new Date(data.effectiveTimeEnd)];
          } else {
            data.date = [];
          }
          if (data.effectiveTimeStart) {
            data.date2 = new Date(data.effectiveTimeStart);
          } else {
            data.date2 = null;
          }
          this.oldMobile = data.mobile;
          this.oldIdNo = data.idNo;
          if (data.bankProvince) {
            const region = this.regionsArr.find(item => {
              return item.name == data.bankProvince;
            });
            this.cityList = region?.children;
          }
          if (data.province) {
            const region = this.regionsArr.find(item => {
              return item.name == data.province;
            });
            this.cityList2 = region?.children;
          }
          this.formData = data;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    // 获取团队列表
    getGroupList() {
      this.queryRoleList();
      this.$http({
        url: '/buz/organizationGroup/getSubGroup',
        type: 'get',
        data: {
          organizationId: this.formData.organizationId
        }
      }).then(res => {
        this.groupList = res.data;
        if (this.groupList.length == 1) {
          this.formData.groupId = this.groupList[0].groupId;
        } else {
          if (this.$route.query.groupId && res.data.find(i => i.groupId == this.$route.query.groupId)) {
            this.formData.groupId = this.$route.query.groupId;
          } else {
            this.formData.groupId = '';
          }
        }
      });
    },
    // 职级列表
    getRankList() {
      this.$http({
        url: '/buz/baseRank/read/all',
        type: 'post',
        data: {}
      }).then(res => {
        this.rankList = res.data;
      });
    },
    // 获取银行列表
    getBankList() {
      this.bankList = this.dic['BANK_TYPE'];
    },
    getCardType() {
      this.$http({
        url: '/system/dic/read/dicList',
        type: 'POST',
        data: {
          code: 'USER_CARD_TYPE'
        }
      }).then(res => {
        this.idTypeList = res.data;
      });
    },
    // 获取民族列表
    getNationList() {
      this.nationList = JSON.parse(Object.getOwnPropertyNames(this.dic['NATION'])[0]);
    },
    // 获取当前机构业务员
    getUserList() {
      this.$http({
        url: '/buz/userBase/getByOrgIds',
        type: 'post',
        data: {
          orgaList: [this.$route.query.organizationId || this.formData.organizationId],
          type: '3'
        }
      }).then(res => {
        this.userList = res.data;
      });
    },
    // 推荐人列表
    getRecommenderList() {
      this.$http({
        url: '/buz/userBase/queryUserByEntryConfig',
        type: 'get',
        data: {
          orgId: this.$route.query.organizationId || this.formData.organizationId
        }
      }).then(res => {
        this.recommenderList = res.data;
      });
    },
    // 获取省市区域数据
    async getRegion() {
      this.regionsArr = await this.$store.dispatch('getRegion');
    },
    // 选择省
    provinceChange(type, name) {
      const data = this.regionsArr.find(item => {
        return item.name == name;
      });
      if (type == 'bank') {
        this.$set(this.formData, 'bankCity', '');
        this.cityList = data.children;
      } else {
        this.$set(this.formData, 'city', '');
        this.cityList2 = data.children;
      }
    },
    // 身份证有效期类型切换
    isLongEffectiveChange() {
      if (this.formData.isLongEffective == 1) {
        this.$set(this.formData, 'date', []);
      }
    },
    // 身份证号修改
    idCardChange(e, val) {
      this.oldIdNo = '';
      this.idEye = false;
      this.$set(this.formData, 'idNo', e.target.value);
      if (!val) {
        const idCard = e.target.value;
        const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (reg.test(idCard)) {
          const date = idCard.substr(6, 4) + '-' + idCard.substr(10, 2) + '-' + idCard.substr(12, 2);
          this.$set(this.formData, 'birthday', date);
        }
        const sex = idCard.substr(16, 1) % 2 == 1 ? '1' : '2';
        this.$set(this.formData, 'sex', sex);
      }
    },
    // 出生日期选择
    changeBirthday(value) {
      this.formData.birthday = filter.filterTime(value, 'YYYY-MM-DD');
    },
    // 银行卡
    cardNoChange(e) {
      this.oldCardNo = '';
      this.cardNoEye = false;
      const cardNo = e.target.value;
      this.$set(this.formData, 'cardNo', e.target.value);
      if (cardNo && cardNo.length > 15 && cardNo.length < 20) {
        this.$http({
          url: '/buz/userCertificate/queryBankByCardNo',
          type: 'GET',
          data: {
            cardNo
          }
        }).then(res => {
          if (res.data) {
            this.getBankList();
            for (let i in this.bankList) {
              if (this.bankList[i] == res.data) {
                this.$set(this.formData, 'bank', i);
              }
            }
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import './base.scss';
</style>
